export const MENU_OPEN = "MENU_OPEN";
export const MENU_CLOSE = "MENU_CLOSE";
export const GET_PRODUCTS_BEGIN = "GET_PRODUCTS_BEGIN";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR ";
export const GET_QUERY_PRODUCTS_BEGIN = "GET_QUERY_PRODUCTS_BEGIN ";
export const GET_QUERY_PRODUCTS_SUCCESS = "GET_QUERY_PRODUCTS_SUCCESS";
export const GET_QUERY_PRODUCTS_ERROR = "GET_QUERY_PRODUCTS_ERROR";
export const GET_SINGLE_PRODUCT_BEGIN = "GET_SINGLE_PRODUCT_BEGIN";
export const GET_SINGLE_PRODUCT_SUCCESS = "GET_SINGLE_PRODUCT_SUCCESS";
export const GET_SINGLE_PRODUCT_ERROR = "GET_SINGLE_PRODUCT_ERROR";
export const GET_RECOMMENDED_PRODUCT_BEGIN = "GET_RECOMMENDED_PRODUCT_BEGIN";
export const GET_RECOMMENDED_PRODUCT_SUCCESS =
  "GET_RECOMMENDED_PRODUCT_SUCCESS";
export const GET_RECOMMENDED_PRODUCT_ERROR = "GET_RECOMMENDED_PRODUCT_ERROR ";
export const GRID_VIEW = "GRID_VIEW";
export const LIST_VIEW = "LIST_VIEW";
export const LOAD_PRODUCTS = "LOAD_PRODUCTS";
export const LOAD_QUERY_PRODUCTS = "LOAD_QUERY_PRODUCTS";
export const UPDATE_SORT = "UPDATE_SORT";
export const SORT_PRODUCTS = "SORT_PRODUCTS";
export const UPDATE_FILTER = "UPDATE_FILTER";
export const FILTER_PRODUCTS = "FILTER_PRODUCTS";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_CART_ITEM = "REMOVE_CART_ITEM";
export const TOGGLE_CART_ITEM_AMOUNT = "TOGGLE_CART_ITEM_AMOUNT";
export const CLEAR_CART = "CLEAR_CART";
export const COUNT_CART_TOTALS = "COUNT_CART_TOTALS";
